import { FSA } from 'flux-standard-action';
import { stringify } from 'qs';

export const ADD_PARAM: '@query_parameter/ADD_PARAM' = '@query_parameter/ADD_PARAM';
export const ADD_FILTER_PARAM: '@query_parameter/ADD_FILTER_PARAM' = '@query_parameter/ADD_FILTER_PARAM';
export const CHANGE_PARAMS: '@query_parameter/CHANGE_PARAMS' = '@query_parameter/CHANGE_PARAMS';
export const CLEAR_PARAMS: '@query_parameter/CLEAR_PARAMS' = '@query_parameter/CLEAR_PARAMS';
export const REMOVE_PARAM: '@query_parameter/CLEAR_PARAM' = '@query_parameter/CLEAR_PARAM';

export enum QuerySearchFilterArt {
  Exos = 'exos',
  Varius = 'varius',
  VariusMed = 'variusMed'
}

export enum QuerySearchFilterForm {
  Oval = 'oval',
  Square = 'square',
  Round = 'round'
}

export interface  QuerySearchFilter {
  art?: QuerySearchFilterArt;
  form?: QuerySearchFilterForm[];
  overflow?: 'overflowWith' | 'overflowWithout';
  backwall?: 'preparedBackWallWith' | 'preparedBackWallWithout';
}

type QuerySword = string | undefined;

export interface QueryParemeterPayload extends QuerySearchFilter {
  filter?: QuerySearchFilter;
  sword?: QuerySword;
  list: 1 | 2;
  tab: 'mine' | 'others' | 'archived';
  from?: string;
  groupKey: string;
  period?: string;
  folderId?: string;
	// password reset stuff
	uuid?: string;
	token?: string;
	hash?: string;
}

export interface QueryParemeterQsParse {
  filter?: QuerySearchFilter;
  sword?: string;
  list?:  1 | 2;
  tab?: 'mine' | 'others' | 'archived';
  groupKey?: string;
  period?: string;
  folderId?: string;
}

export type QueryParamType = 'filter' | string;
export type QueryParamArgumentType = QuerySearchFilter | QuerySword | 1 | 2;

export interface QueryParamArgument {
  param: QueryParamArgumentType;
  type: QueryParamType;
}

export interface QueryParemeterDispatch {
  addFilterParam(payload: QuerySearchFilter): FSA<string, QuerySearchFilter>;
  addQueryParam(type: QueryParamType, param: QueryParamArgument): FSA<string, QueryParamArgument>;
  changeQueryParams(params: QueryParemeterQsParse): FSA<string, QueryParemeterQsParse>;
  clearQueryParams(): FSA<string, undefined>;
  removeQueryParam(param: QueryParamArgument): FSA<string, QueryParamArgument>;
} 

export const addFilterParam = (payload: QuerySearchFilter): FSA<string, QuerySearchFilter> => ({
  type: ADD_FILTER_PARAM,
  payload, 
});

export const addQueryParam = (type: QueryParamType, param: QueryParamArgumentType): FSA<string, QueryParamArgument> => ({
  type: ADD_PARAM,
  payload: {
    param: type === 'filter' ? stringify(param) : param,
    type,
  },
});

export const changeQueryParams = (params: QueryParemeterQsParse): FSA<string, QueryParemeterQsParse> => ({
  type: CHANGE_PARAMS,
  payload: params,
});

export const clearQueryParams = (): FSA<string, undefined> => ({
  type: CLEAR_PARAMS
});

export const removeQueryParam = (type: QueryParamType): FSA<string, {type: QueryParamType}> => ({
  type: REMOVE_PARAM,
  payload: {
    type
  },
});